import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const RelatedBibles = ({ bibles = [] }) => {
  if (!bibles.length) return null;

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-heading font-bold text-foreground">
        Biblias relacionadas
      </h2>
      
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {bibles.map((bible) => (
          <Link
            key={bible.id}
            to={`/bible-detail-screen?id=${bible.id}`}
            className="group block"
          >
            <div className="bg-card rounded-lg shadow-subtle hover:shadow-modal transition-gentle hover-lift overflow-hidden">
              <div className="relative aspect-[3/4] overflow-hidden bg-muted">
                <Image
                  src={bible.image || '/placeholder.jpg'}
                  alt={`Portada de ${bible.title}`}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-2 left-2">
                  <div className="bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-full">
                    Biblia
                  </div>
                </div>
              </div>
              
              <div className="p-3 space-y-2">
                <h3 className="font-medium text-sm leading-tight line-clamp-2 text-foreground group-hover:text-primary transition-colors">
                  {bible.title}
                </h3>
                <p className="text-xs text-muted-foreground line-clamp-1">
                  {bible.version || 'Versión no especificada'}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-primary">
                    ${bible.price?.toFixed(2) || '0.00'}
                  </span>
                  {bible.available ? (
                    <span className="text-xs text-green-600 font-medium">
                      Disponible
                    </span>
                  ) : (
                    <span className="text-xs text-red-500 font-medium">
                      No disponible
                    </span>
                  )}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedBibles;

